import { render, staticRenderFns } from "./map-bottom-popup-swiper.vue?vue&type=template&id=711cede1"
import script from "./map-bottom-popup-swiper.vue?vue&type=script&lang=js"
export * from "./map-bottom-popup-swiper.vue?vue&type=script&lang=js"
import style0 from "./map-bottom-popup-swiper.vue?vue&type=style&index=0&id=711cede1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports